import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button, FormGroup, Label, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { fetchEmployeeDropdown, getpayRegSummaryList, clearpayRegSummaryList } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomSelect from "components/Common/custom-select";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { orderBy } from "lodash";
import Swal from 'sweetalert2';

const PayrollReportPaySummary = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);

  const {
    dropdownData,
    payregsummaryList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? {},
    payregsummaryList: state.PayrollReportsReducer?.payregsummaryList ?? [],
    loading: state.PayrollReportsReducer?.loading,
    error: state.PayrollReportsReducer?.error,
    success: state.PayrollReportsReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0]?.unit_id
    dispatch(fetchEmployeeDropdown(unitId));
  }, [dispatch]);

  const departmentOptions = dropdownData?.department_list?.map((item) => ({ label: item.depart_name, value: item.depart_id, })) || [];

  const formik = useFormik({
    initialValues: {
      department: "0",
      month: "",
      dropdownData: {},
      payregsummaryList: [],
    },
    validationSchema: Yup.object({
      month: Yup.string().required("Month is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("unit_id", authDetails?.unit_id || 0);
      formData.append("emp_dep", values.department || 0);
      formData.append("month", values.month || "");
      dispatch(getpayRegSummaryList(formData));
    },
  });

  const columns = [
    { Header: "S.NO", Cell: ({ row }) => payregsummaryList.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "DEPARTMENT", accessor: "department" },
    { Header: "PAID_DAYS", accessor: "net_paid_days", sum: true },
    { Header: "BASIC", accessor: "basic", sum: true },
    { Header: "DA", accessor: "da", sum: true },
    { Header: "HRA", accessor: "hra", sum: true },
    { Header: "CONVEYANCE", accessor: "conv", sum: true },
    { Header: "WASHING", accessor: "washing", sum: true },
    // { Header: "Fuel", accessor: "fuel", sum: true },
    // { Header: "OT", accessor: "ot", sum: true },
    // { Header: "OT Salary", accessor: "otSalary", sum: true },
    // { Header: "Travel", accessor: "travel", sum: true },
    { Header: "Gross", accessor: "gross_earnings", sum: true },
    { Header: "CANTEEN", accessor: "canteen", sum: true },
    { Header: "LATE", accessor: "late", sum: true },
    { Header: "TEA", accessor: "tea", sum: true },
    { Header: "DEDUCTION", accessor: "gross_deduction", sum: true },
    { Header: "AMOUNT_PAYABLE", accessor: "net_amount_payable", sum: true },
    // { Header: "ESI", accessor: "esi", sum: true },
    // { Header: "PF", accessor: "pf", sum: true },
    // { Header: "Advance", accessor: "advance", sum: true },
    // { Header: "Bus", accessor: "bus", sum: true },
    // { Header: "Uniform", accessor: "uniform", sum: true },
    // { Header: "Food", accessor: "food", sum: true },
    // { Header: "MESS", accessor: "mess", sum: true },
    // { Header: "Fine", accessor: "fine", sum: true },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Payroll / Reports / Salary Reports" breadcrumbItem="Pay Register Summary" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Department</Label>
                  <Select
                    options={departmentOptions}
                    name="department"
                    value={departmentOptions.find((opt) => opt.value === formik.values.department) || 0}
                    onChange={(selected) => formik.setFieldValue("department", selected ? selected.value : 0)}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Month <span className="text-danger">*</span></Label>
                  <CustomMonthPicker
                    name="month"
                    value={formik.values.month}
                    onChange={(date) => { formik.setFieldValue("month", date); }}
                    onBlur={() => { console.log("Blurred! Value is:", formik.values.month); }}
                    disableFuture={true}
                    className="form-control form-control-sm"
                    classNamePrefix="react-select"
                    isClearable={true}
                  />
                  {formik.touched.month && formik.errors.month && (
                    <div className="text-danger mt-1">{formik.errors.month}</div>
                  )}
                </Col>
                <Col md={4} className="d-flex align-items-end justify-content-end">
                  <Button type="submit" className="btn button-search me-2"><i className="fas fa-search me-1" /> Search</Button>
                  {payregsummaryList && payregsummaryList.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export me-2 ms-2"> <i className="fas fa-file-export me-1" /> Export</DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(payregsummaryList, authDetails?.unit_fullname, authDetails?.unit_address, "Section Wage Register Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(payregsummaryList, authDetails?.unit_fullname, authDetails?.unit_address, "Section Wage Register Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                  <Button type="reset" className="btn button-cancel"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                        showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                      }).then((result) => {
                        if (result.isConfirmed) {
                          formik.handleReset();
                          dispatch(clearpayRegSummaryList());
                        }
                      });
                    }}
                  >
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TableContainerColumnTotal columns={columns} data={payregsummaryList || []} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PayrollReportPaySummary;
